import { WebPageDetails } from "@/services/analytics/platforms/adobe-analytics/models";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { Store } from "vuex";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import { GETTERS } from "@/store/customer";

export class AdobeCancelOrderPageLoadEvent extends AdobePageLoadEvent {
  constructor(store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      name: `order:cancel-order`,
      language: window.navigator.language ? window.navigator.language.toLowerCase() : 'not-set',
      previousPage: document.referrer,
      pageViews: {
        value: 1,
      },
      siteRegion: store.state.ui.countryProfile.countryCode || '',
    } as WebPageDetails);

    Object.assign(this.account, {
      loginStatus: !!store.getters[GETTERS.IS_LOGGED_IN],
      userID: store.state.customer.profile?.customerIdHash,
    })
  }
}